export default "__VITE_ASSET__48320e1d__"